export default __webpack_public_path__ + "static/media/home.ea636ce2.png";